import PropTypes from "prop-types";

const LoadingCard = ({ title }) => {
  return (
    <div className="flex items-center justify-center min-h-screen background-page-color w-screen">
      <div className="flex flex-col items-center justify-center text-center gap-4 max-w-2xl mx-auto">
        <div className="border-t-4 border-blue-500 border-solid rounded-full w-16 h-16 animate-spin"></div>
        <p className="mt-4 text-base text-gray-600">{title}</p>
      </div>
    </div>
  );
};

LoadingCard.propTypes = {
  title: PropTypes.string.isRequired,
};

export default LoadingCard;
